import { render, staticRenderFns } from "./EmailAddressList.vue?vue&type=template&id=1bcf270a"
import script from "./EmailAddressList.vue?vue&type=script&lang=js"
export * from "./EmailAddressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports